/* import __COLOCATED_TEMPLATE__ from './device-preferences.hbs'; */
import Component from '@ember/component';
import { showModal } from 'sh-www/utils/modal-controls';

const DevicePreferences = Component.extend({
  classNames: ['device-preferences'],

  actions : {
    /**
     * @param {UserDevice} device
     */
    openEditDeviceModal(device) {
      showModal(this, 'settings/edit-device-nicename', device);
    },

    /**
     * @param {string} deviceType     of type DevicePreferences.DEVICE_TYPE_*
     */
    openPushDisabledModal : function(deviceType) {
      let modalModel = {
        isIos : deviceType === DevicePreferences.DEVICE_TYPE_IOS,
        isAndroid : deviceType === DevicePreferences.DEVICE_TYPE_ANDROID
      };

      showModal(this, 'settings/push-disabled', modalModel);
    }
  }
});

DevicePreferences.reopenClass({
  DEVICE_TYPE_IOS : 'ios',
  DEVICE_TYPE_ANDROID : 'android'
});

export default DevicePreferences;
